import Counter from '@atoms/Counter/Counter';
import { useEffect, useState } from 'react';

export interface IOpeningsSelector {
  readonly doorsLabel: string;
  readonly windowsLabel: string;
  readonly increaseAriaLabel: string;
  readonly decreaseAriaLabel: string;
  readonly metricMeterSquareLabel: string;
  readonly initialDoors?: number;
  readonly initialWindows?: number;
  readonly doorAreaSize: number;
  readonly windowAreaSize: number;
  readonly onChangeDoors: (count: number) => void;
  readonly onChangeWindows: (count: number) => void;
}

export const DOOR_AREA_SIZE = 2; //m2
export const WINDOW_AREA_SIZE = 1.5; //m2

const OpeningsSelector = ({
  doorsLabel,
  windowsLabel,
  metricMeterSquareLabel,
  initialDoors = 0,
  initialWindows = 0,
  doorAreaSize = DOOR_AREA_SIZE,
  windowAreaSize = WINDOW_AREA_SIZE,
  onChangeDoors,
  onChangeWindows,
  increaseAriaLabel,
  decreaseAriaLabel,
}: IOpeningsSelector) => {
  const [doors, setDoors] = useState(initialDoors);
  const [windows, setWindows] = useState(initialWindows);

  useEffect(() => onChangeDoors(doors), [doors]);
  useEffect(() => onChangeWindows(windows), [windows]);

  return (
    <div className="tw-flex tw-gap-4 tw-pt-4 md:tw-gap-8">
      <Counter
        label={doorsLabel}
        count={doors}
        areaSize={doorAreaSize}
        areaLabel={metricMeterSquareLabel}
        increaseAriaLabel={increaseAriaLabel}
        decreaseAriaLabel={decreaseAriaLabel}
        onChange={setDoors}
      />
      <Counter
        label={windowsLabel}
        count={windows}
        areaSize={windowAreaSize}
        areaLabel={metricMeterSquareLabel}
        increaseAriaLabel={increaseAriaLabel}
        decreaseAriaLabel={decreaseAriaLabel}
        onChange={setWindows}
      />
    </div>
  );
};

export default OpeningsSelector;
